import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { CarrierColumnContainer } from '../../../containers/carrier-column-container';
import { FulfillmentPlanOrderGridStatus } from '../../../enums/fulfillmentplan-order-grid-status';
import { DashPlaceholder } from './dash-placeholder';
import { messages } from './messages';

const CarrierColumn = ({ fulfillmentPlanId }) => {
  const { labelConfiguration, orderGridStatus } = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }),
  );
  const { sellerLabelProviderId, serviceId, serviceCollectionGuid } = labelConfiguration ?? {};

  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const sellerLabelProvider = sellerLabelProviders.find((slp) => slp.sellerLabelProviderId === sellerLabelProviderId);
  const labelProviders = useSelector(Global.selectReferenceDatagetProviders);
  const labelProvider = sellerLabelProvider?.labelProviderId
    ? labelProviders.find((lp) => lp.labelProviderId === sellerLabelProvider.labelProviderId)
    : undefined;
  const service = useSelector((state) => Global.selectSellerServiceById(state, { serviceId }));

  const carrierId = labelProvider?.carrierId ?? service?.carrierId;
  const labelProviderId = labelProvider?.labelProviderId ?? service?.labelProviderId;

  const serviceCollectionConditionsForPlaceholder =
    serviceCollectionGuid && orderGridStatus !== FulfillmentPlanOrderGridStatus.Shipped.name && !carrierId;
  if (serviceCollectionConditionsForPlaceholder) {
    return <DashPlaceholder />;
  }

  return carrierId ? <CarrierColumnContainer carrierId={carrierId} providerId={labelProviderId} /> : null;
};

CarrierColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const Carrier = {
  getMessageDescriptor: () => messages.carrier,
  id: 'carrier',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    const shouldRenderEmpty = !data || (isExpanded && !isFirstRow);
    if (shouldRenderEmpty) {
      return null;
    }

    return <CarrierColumn fulfillmentPlanId={data.id} />;
  },
};
